import { applyLinkBrandParam } from '@/lib/appBootstrap/brandHintFromUrl';
import type { BrandSource } from './types';
import { namesABrand } from './types';

export const queryBrandSource: BrandSource = {
  name: 'query',
  resolve: ({ url, hostname }) => {
    const identifiers = {
      uuid: url.searchParams.get('brandUuid') ?? undefined,
      brandID: url.searchParams.get('brandID') ?? url.searchParams.get('brandId') ?? undefined,
      code: url.searchParams.get('brand') ?? applyLinkBrandParam({ url, hostname }) ?? undefined,
    };

    return namesABrand(identifiers) ? identifiers : null;
  },
};
